<div class="border-b border-gray-200 bg-white px-4 py-5 sm:px-6">
  <div class="-ml-4 -mt-2 flex flex-wrap items-center justify-between sm:flex-nowrap">
    <div class="ml-4 mt-2">
      <h3 class="text-base font-semibold leading-6 text-gray-900">Scheduled Notifications</h3>
      <p class="mt-1 text-sm text-gray-500">Create and manage scheduled email notifications.</p>
    </div>
    <div class="ml-4 mt-2 flex-shrink-0">
      @if (showAdd) {
      <button type="button" (click)="showScheduledNotificationModal()"
        class="relative inline-flex items-center rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">
        Add Notification</button>
      }
    </div>
  </div>
</div>

<div class="flex flex-col">
  <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
    <div class="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
      <div class="overflow-hidden">
        @if (!isInit && scheduledNotifications.length <= 0) { <div class="m-4">
          <div class="border-l-4 border-blue-400 bg-blue-50 p-4 mb-2">
            <div class="flex">
              <div class="ml-3">
                <p class="text-sm text-blue-700">
                  No Scheduled Notifications
                </p>
              </div>
            </div>
          </div>
      </div>
      }
      @if (!isInit && scheduledNotifications.length > 0) {
      <table class="min-w-full divide-y divide-gray-200">
        <thead class="bg-gray-50">
          <tr>
            <th scope="col" class="px-6 py-3 text-left text-sm font-semibold text-gray-900">Name</th>
            <th scope="col" class="px-6 py-3 text-left text-sm font-semibold text-gray-900">Schedule</th>
            <th scope="col" class="px-6 py-3 text-left text-sm font-semibold text-gray-900">Last Sent</th>
            <th scope="col" class="relative px-6 py-3 text-left text-sm font-medium text-gray-500">
              <span class="sr-only">View receipt</span>
            </th>
          </tr>
        </thead>
        <tbody class="divide-y divide-gray-200 bg-white">
          @for (scheduledNotification of scheduledNotifications; track scheduledNotification) {
            <tr>
              <td class="whitespace-nowrap px-6 py-4 text-sm text-gray-500">
                <a class="link block" (click)="showScheduledNotificationModal(scheduledNotification.id)">{{
                  scheduledNotification.name }}</a>
                {{getNotificationName(scheduledNotification.key)}}
                @if (scheduledNotification.notificationEmails) {
                  <div>+{{countNotificationEmails(scheduledNotification.notificationEmails)}} CC email addresses</div>
                }
              </td>
              <td class="whitespace-nowrap px-6 py-4 text-sm text-gray-500 align-top"> {{ scheduledNotification.schedule }} at
                {{ toLocalTimeDisplay(scheduledNotification.displayTime) }}
              </td>
              <td class="whitespace-nowrap px-6 py-4 text-sm text-gray-900 align-top">
                <time datetime="2020-01-01">{{ scheduledNotification?.lastSentWhen?.toJSDate() | date:
                  'MM/dd/yyyy'}}</time>
              </td>
            </tr>
          }
        </tbody>
      </table>
      }
    </div>
  </div>
</div>
</div>